export default __webpack_public_path__ + "static/1343-28b38ab09112e6c4c10b1580ddee8647.gif";